import { FillType } from '~/static/enums/components/color-input'
import { ObjectType } from '~/static/enums/object-type'
import { TextAlign } from '~/static/enums/text-align'
import { VersionMigrator } from '~/utils/editor/versioning/migrators'
import { ObjectPropsV1, ObjectPropsV2, migrate as migrateObject, FabricV5Data } from '~/utils/editor/versioning/object'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export const ActualVersionNumber = Versions.V2
export type ActualVersion = TextPropsV2

export interface TextPropsV1 extends ObjectPropsV1 {
  type?: ObjectType.Text

  text?: string
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  underline?: boolean
  linethrough?: boolean
  width?: number
  height?: number
  italic?: boolean
  fontFamily?: string
  align?: TextAlign
  lineSpacing?: number
  fontSize?: number
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  round?: number

  data?: FabricV5Data & { text?: string, objects?: { text: string }[], width?: number, height?: number }
  textData?: { text?: string }
}

export interface TextPropsV2 extends ObjectPropsV2 {
  type?: ObjectType.Text

  text?: string
  areaWidth?: number
  areaHeight?: number
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  underline?: boolean
  linethrough?: boolean
  width?: number
  height?: number
  italic?: boolean
  fontFamily?: string
  align?: TextAlign
  lineSpacing?: number
  fontSize?: number
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  round?: number
}

export const migrate: VersionMigrator<TextPropsV2> = (data: object) => {
  if ('version' in data && data.version === Versions.V2) {
    return data as TextPropsV2
  }

  const dataV1 = data as TextPropsV1

  return {
    type: ObjectType.Text,  
    ...migrateObject(dataV1),
    version: Versions.V2,
    title: 'Текст',
    text: dataV1.text ??
      dataV1.textData?.text ??
      dataV1.data?.text ??
      dataV1.data?.objects?.[0]?.text ??
      'Текст',
    areaWidth: dataV1.data?.width,
    areaHeight: dataV1.data?.height,
    colorType: dataV1.colorType,
    color: dataV1.color,
    opacity: dataV1.opacity,
    underline: dataV1.underline,
    linethrough: dataV1.linethrough,
    width: dataV1.width,
    height: dataV1.height,
    italic: dataV1.italic,
    fontFamily: dataV1.fontFamily,
    align: dataV1.align,
    lineSpacing: dataV1.lineSpacing,
    fontSize: dataV1.fontSize,
    shadow: dataV1.shadow,
    shadowColor: dataV1.shadowColor,
    shadowOpacity: dataV1.shadowOpacity,
    shadowX: dataV1.shadowX,
    shadowY: dataV1.shadowY,
    shadowBlur: dataV1.shadowBlur,
    round: dataV1.round,
  } as TextPropsV2
}
